export function formatCurrency(amount, currency, locale) {
  if (amount === void 0) {
    amount = 0;
  }
  const amountNumber = Number(amount);
  return currency ? Intl.NumberFormat(locale, {
    style: 'currency',
    unitDisplay: 'narrow',
    currency,
    maximumFractionDigits: getPrecision(amountNumber)
  }).format(amountNumber) : String(amount);
}
function getPrecision(amount) {
  var _amount$toString$spli;
  return ((_amount$toString$spli = amount.toString().split('.')[1]) == null ? void 0 : _amount$toString$spli.length) || 0;
}
//# sourceMappingURL=format-currency.js.map